import { Typography } from '@mui/material'
import { FC, useEffect, useState } from 'react'
import { Trans } from 'react-i18next'

const NEXT_VIDEO_START_TIME = 30

const CountdownLabel: FC<{ onTimeup: () => void }> = ({ onTimeup }) => {
  const [count, setCount] = useState(NEXT_VIDEO_START_TIME)

  useEffect(() => {
    if (count <= 0) {
      onTimeup()
      return
    }
    const id = setTimeout(() => {
      setCount((value) => value - 1)
    }, 1000)

    return () => {
      clearTimeout(id)
    }
  }, [count, onTimeup])

  return (
    <Typography>
      <Trans i18nKey='play_next_movie_after_sec' values={{ sec: count }} />
    </Typography>
  )
}

export default CountdownLabel
